var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.499,
    height: 79.744,
    viewBox: "0 0 86.499 79.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 86.499,
    height: 79.744,
    fill: "#f5b85b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43606",
    "data-name": "Path 43606",
    d: "M86.5,24.162V72.479a.756.756,0,0,0-.129.207c-1.02,4.516-4.171,7.056-8.777,7.056q-34.42,0-68.84,0A8.435,8.435,0,0,1,.005,71.018Q-.006,48.338,0,25.659A8.444,8.444,0,0,1,8.8,16.9q5.11-.009,10.22,0h.918c0-2.8-.006-5.478,0-8.151A8.439,8.439,0,0,1,28.668.007q14.57-.014,29.141,0a8.438,8.438,0,0,1,8.754,8.715c.009,2.421,0,4.843,0,7.264V16.9c3.936,0,7.737-.058,11.535.017a8.194,8.194,0,0,1,7.665,5.028,17.771,17.771,0,0,1,.734,2.218M83.12,42.041c-.36.1-.6.153-.841.225q-19,5.752-38.009,11.486A3.448,3.448,0,0,1,42.4,53.8Q25.319,48.675,8.264,43.477c-1.6-.485-3.2-.956-4.883-1.457v.962q0,13.893,0,27.787c0,3.54,2.063,5.6,5.617,5.6h68.5c3.558,0,5.625-2.053,5.625-5.589q0-13.894,0-27.787ZM23.333,16.9H35.042a7.28,7.28,0,0,1,.76.012,1.681,1.681,0,0,1,.033,3.348,7.2,7.2,0,0,1-.844.017q-13.133,0-26.267,0a5.069,5.069,0,0,0-5.342,5.359q-.01,6.039,0,12.078v.741c.384.125.7.236,1.024.333Q23.447,44.559,42.495,50.3a3.127,3.127,0,0,0,1.7-.046Q58.607,45.933,73,41.552c3.359-1.018,6.717-2.039,10.117-3.071v-.872q0-5.912,0-11.824c0-3.425-2.095-5.506-5.535-5.507q-13.007,0-26.014,0a6.507,6.507,0,0,1-.927-.025,1.678,1.678,0,0,1,0-3.328,5.859,5.859,0,0,1,.843-.024q5.363,0,10.726,0h.921V10.881h-39.8Zm.182-9.505H63.01a3.557,3.557,0,0,0-.082-.5,5.05,5.05,0,0,0-4.937-3.5q-8.9-.014-17.805,0c-3.938,0-7.876-.015-11.814.006a4.864,4.864,0,0,0-4.857,4",
    transform: "translate(0 0)",
    fill: "#f5b85b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43607",
    "data-name": "Path 43607",
    d: "M94.721,186.2v.947q0,13.893,0,27.787c0,3.536-2.067,5.589-5.625,5.589H20.6c-3.554,0-5.617-2.055-5.617-5.6q0-13.893,0-27.787v-.962c1.68.5,3.283.972,4.883,1.457Q36.928,192.81,54,197.961a3.451,3.451,0,0,0,1.875-.048Q74.884,192.2,93.88,186.428c.239-.072.482-.129.841-.225",
    transform: "translate(-11.601 -144.162)",
    fill: "#f5b85b",
    opacity: 0.155
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43608",
    "data-name": "Path 43608",
    d: "M104.2,18.981a4.864,4.864,0,0,1,4.857-4c3.938-.021,7.876-.006,11.814-.006q8.9,0,17.805,0a5.05,5.05,0,0,1,4.937,3.5,3.557,3.557,0,0,1,.082.5Z",
    transform: "translate(-80.679 -11.588)",
    fill: "#f5b85b",
    opacity: 0.142
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43609",
    "data-name": "Path 43609",
    d: "M157.972,138.751q-3.8,0-7.592,0c-1.576,0-2.161-.573-2.163-2.116q-.006-3.67,0-7.339c0-1.4.618-2.028,1.992-2.03q7.8-.009,15.607,0c1.374,0,1.991.633,1.994,2.028q.01,3.712,0,7.424c0,1.429-.62,2.029-2.077,2.032q-3.88.007-7.761,0m-6.307-3.436h12.7v-4.657h-12.7Z",
    transform: "translate(-114.763 -98.539)",
    fill: "#f5b85b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43610",
    "data-name": "Path 43610",
    d: "M185.947,74.9a1.683,1.683,0,0,1-.03,3.366,1.683,1.683,0,1,1,.03-3.366",
    transform: "translate(-142.66 -57.995)",
    fill: "#f5b85b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 12.703,
    height: 4.657,
    transform: "translate(36.902 32.119)",
    fill: "#f5b85b",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic1);
export default __webpack_public_path__ + "static/media/topic1.63d5392ae4c319b3fa2aaff1c18b1612.svg";
export { ForwardRef as ReactComponent };